'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { trackAdsProductView } from '@/app/_lib/analytics/ads';

/**
 * Tracks product views via Route Handler instead of Server Action.
 * Uses sendBeacon for fire-and-forget tracking that doesn't block navigation.
 * This avoids RSC errors when bots render pages with JS enabled.
 */
const ProductViewTracker = t0 => {
  const $ = _c(3);
  const {
    sub_product_id
  } = t0;
  let t1;
  let t2;
  if ($[0] !== sub_product_id) {
    t1 = () => {
      if (sub_product_id) {
        const payload = JSON.stringify({
          event: "PRODUCT:VIEW",
          data: {
            sub_product_id
          }
        });
        navigator.sendBeacon("/api/track", payload);
        trackAdsProductView(sub_product_id);
      }
    };
    t2 = [sub_product_id];
    $[0] = sub_product_id;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
};
export default ProductViewTracker;